import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 2.66 3.93',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Camada_2" data-name="Camada 2">
        <path
          fill={fill}
          d="M1.33,3.93h0A4,4,0,0,1,0,1.39,1.25,1.25,0,0,1,1.33,0,1.25,1.25,0,0,1,2.66,1.39,4,4,0,0,1,1.37,3.92Zm0-3.81A1.16,1.16,0,0,0,.12,1.39a3.84,3.84,0,0,0,1.21,2.4,3.84,3.84,0,0,0,1.21-2.4A1.16,1.16,0,0,0,1.33.12Z"
        />
        <path
          fill={fill}
          d="M1.33,2.12a.77.77,0,1,1,.77-.77A.77.77,0,0,1,1.33,2.12Zm0-1.41A.65.65,0,1,0,2,1.35.64.64,0,0,0,1.33.71Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
